import {RouteConfig} from 'vue-router';

import Parties from './pages/Parties.vue';
import Party from './pages/Party.vue';

import PartyComments from './pages/Comments.vue';
import PartyTaskEvaluations from './pages/TaskEvaluations.vue';
import PartyEvaluations from './pages/Evaluations.vue';
import PartyFiles from './pages/Files.vue';
import PartyGeneral from './pages/General.vue';
import PartyInformation from './pages/Information.vue';
import PartyNeeds from './pages/PartyNeeds.vue';
import PartySocialInquiries from './pages/PartySocialInquiries.vue';
import PartyStatements from './pages/Statements.vue';
import PartyWorkTaskRules from './pages/WorkTaskRules.vue';
import PartyInterest from './pages/Interest.vue';
import PartyVisitPlan from './pages/VisitPlan.vue';

export default [
    {
        path: '/:tenantId/parties',
        name: 'Parties',
        component: Parties,
        props: (route) => ({ tenantId: route.params.tenantId })
    },
    {
        path: '/:tenantId/parties/:partyId',
        name: 'Party',
        component: Party,
        props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId }),
        children: [
            {
                path: '/:tenantId/parties/:partyId/comments',
                name: 'PartyComments',
                component: PartyComments,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/evaluations',
                name: 'PartyEvaluations',
                component: PartyEvaluations,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/task-evaluations',
                name: 'PartyTaskEvaluations',
                component: PartyTaskEvaluations,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/files',
                name: 'PartyFiles',
                component: PartyFiles,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/general',
                name: 'PartyGeneral',
                component: PartyGeneral,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/interest',
                name: 'PartyInterest',
                component: PartyInterest,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/information',
                name: 'PartyInformation',
                component: PartyInformation,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/needs',
                name: 'PartyNeeds',
                component: PartyNeeds,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/social-inquiries',
                name: 'PartySocialInquiries',
                component: PartySocialInquiries,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/statements',
                name: 'PartyStatements',
                component: PartyStatements,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/work-task-rules',
                name: 'PartyWorkTaskRules',
                component: PartyWorkTaskRules,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
            {
                path: '/:tenantId/parties/:partyId/party-visit-plan',
                name: 'PartyVisitPlan',
                component: PartyVisitPlan,
                props: (route) => ({ tenantId: route.params.tenantId, partyId: route.params.partyId })
            },
        ]
    }
] as RouteConfig[];
